import axios from "@/axios/axios";

const actions = {
  async GET_ALL(context){
    try{
      let {data} = await axios.get('ua_all', {
        params: {
          users_id: context.rootGetters['appUser/id']
        }
      });
      let currentAccountNumber = localStorage.currentAccountNumber;
      let aparts = Object.values(data).reduce((accumulator, currentApart) => {
        if(!accumulator.map(a => a.id).includes(currentApart.id)){
          accumulator.push(currentApart);
        }
        return accumulator;
      }, []).filter(apart => apart.address && apart.address[0] && !apart.address[0].is_recently_imported);

      context.commit('SET_APARTS', aparts);
      let selectedApart = {};
      if(aparts.length){
        if(currentAccountNumber){
          let apart = aparts.find(a => a.account_number === currentAccountNumber);

          if(apart){
            selectedApart = apart;
          }
          else{
            selectedApart = aparts[0];
          }
        }
        else{
          selectedApart = aparts[0];
        }
        context.commit('appUser/client/SET_ADD_MODE', false, {root: true});
      }
      else{
        context.commit('appUser/client/SET_ADD_MODE', true, {root: true});
      }

      if(selectedApart.account_number){
        context.dispatch('UPDATE_SELECTED', selectedApart);
      }

    }
    catch(e){
      console.error(e);
      context.commit('SET_APARTS', []);
    }
  },
  UPDATE_SELECTED(context, payload){
    localStorage.currentAccountNumber = payload.account_number;
    context.commit('SET_SELECTED', payload);
    context.dispatch('appUser/client/UPDATE_APARTMENT_DATA', null, {root: true});
    context.dispatch('GET_OWNERS');
  },
  async UPDATE_SEND_CHARGE_EMAIL(context, {value, apart}){
    try{
      await axios.put('apart_by_owner/' + apart.id, {
        send_charge_email: value,
      });
      context.commit('SET_SEND_CHARGE_EMAIL', {value: value, apart: apart});
    }
    catch(e){
      console.error(e);
    }
  },
  async GET_OWNERS(context){
    try{
      let {data} = await axios.get('u_apartment_users', {
        params: {
          account_number: context.getters.selected.account_number,
        }
      });
      context.commit("SET_OWNERS", data);
    }
    catch(e){
      context.commit("SET_OWNERS", []);
    }
  },
  async GET_LE_INFO({commit, getters}){
    try{
      let {data} = await axios.get('lentities', {
        params: {
          id: getters.selected.address[0].legal_entities_id
        }
      });

      commit("SET_LE_INFO", data);
    }
    catch(e){
      commit("SET_LE_INFO", {vat: 0});
    }
  }
};

export default actions;
